import Photo from "@blocks/Photo";
import { useSidepanelContext } from "@contexts/sidepanel";
import React, { useCallback } from 'react';

export default function useSalonGalleryComponent(config: Config) { 
    const sidepanel = useSidepanelContext()

    const onClick = async (photo: Interfaces.Photo) => {
        sidepanel.close()
        await config.onChoose(photo)
    }

    return useCallback((props: ArchiveComponentProps<Interfaces.Photo>) => (
        <Photo data={props.data} onClick={onClick} />
    ), [])
}

interface Config {
    onChoose(photo: Interfaces.Photo): Promise<void>
}